import styles from "./range.module.css";
export function Skill({ name, per }) {
    const a = per;
    const b = (100 - Number(per)) * 2;
    console.log(b);
    return (
      <div className={styles.skill}>
        <h3>
          {name + " "}{" "}
          <span style={{ color: "rgb(157, 152, 152)" }}>{per + "%"}</span>
        </h3>
        <div style={{ backgroundColor: "rgb(85, 82, 82)", borderRadius: "20px" }}>
          <div
            style={{
              width: `${a}%`,
              borderColor: "rgb(85, 82, 82)",
            }}
            className={styles.range}
          ></div>
        </div>
      </div>
    );
  }
  